<template>
	<div class="page-content">
		
		<kyaneos-header />

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">La marché de la revente</p>
		</div>

		<el-title :index="1">
			Les transactions effectives
		</el-title>

		<div class="section">
			<div class="part">
				<div class="tle-row">
					
					<div class="tle-col half">
						<el-image
							:parent_data="active_study.etudeData.scpi.revente.images[0]"
							property="src"
							:editable="true"
							max_height="150px"
							edition_position="right"
						/>
						<el-textarea
							:parent_data="active_study.etudeData.scpi.revente.images[0]"
							property="description"
							:editable="true"
							class="text-center text-italic image-description"
						/>
					</div>
					<div class="tle-col half">
						<div class="part part-images">
							<el-table :table="table_population" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="yanport-params">
			<el-yanport-params
				save_parent="page_5"
			/>
		</div>
		<error v-if="!active_study.etudeData.yanportData5" :show-in-read-mode="true" />
		<div v-else class="tle-row q-mb-sm yanport-kpi">
			<div class="tle-col one-fifth">
				<el-square
				:parent_data="
					active_study.etudeData.yanportData5.kpiAncien.stock
				"
				property="count"
				label="Stock"
				format="number"
				:sub_value="{value: 'Nombre de références ' + text_period}"
				/>
			</div>
			<div class="tle-col one-fifth">
				<el-square
				:parent_data="
					active_study.etudeData.yanportData5.kpiAncien.prix.values
				"
				property="50.0"
				label="Prix"
				format="number"
				suffix="€/m²"
				:sub_value="{value: 'Prix médian au m²  '+ text_period}"
				/>
			</div>
			<div class="tle-col one-fifth">
				<el-square
				:parent_data="
					active_study.etudeData.yanportData5.kpiAncien.duree.values
				"
				property="50.0"
				label="Durée"
				format="number"
				suffix="jours"
				:sub_value="{value: 'Durée médiane de publication ' + text_period}"
				/>
			</div>
			<div class="tle-col one-fifth">
				<el-square
				:parent_data="
					active_study.etudeData.yanportData5.kpiAncien.rendementLocatif.values
				"
				property="50.0"
				label="Investissement"
				format="number"
				suffix="%"
				:sub_value="{value: 'Rendement locatif brut ' + text_period}"
				/>
			</div>
			<div class="tle-col one-fifth">
				<el-square
				:parent_data="
					active_study.etudeData.yanportData5.kpiAncien.margeNegociation.values
				"
				property="50.0"
				label="Marge de négo."
				format="number"
				suffix="%"
				:sub_value="{value: 'Marge de négociation ' + text_period}"
				/>
			</div>
			<p>Source : Données statistiques Yanport</p>
		</div>
		<el-title :index="2">
			Offres actuelles
		</el-title>

		<div class="q-mb-sm">
			<el-table
				class="table-offres"
				:table="table_offres"
				:lines-obj="active_study.etudeData.scpi.revente"
				lines-field="offres_table_lignes"
				lines-box-class="left lefter toper"
				nb-lines-max="5"
			/>
		</div>

		<div class="comment">
			<el-textarea
				class="detail-site"
				:parent_data="active_study.etudeData.scpi.revente"
				property="commentaire"
				:editable="true"
				placeholder="Commentaire"
				:height="active_study.etudeData.scpi.revente.offres_table_lignes == 5 ? '20px' : '100px'"
				overflow_edit='hidden scroll'
				text_align="justify"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import MapComponent from "@/components/study/editor/elements/MapComponent";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";
import ElYanportParams from "@/components/study/editor/elements/el-yanport-params.vue";

export default {
	name: "page-kyaneos-5",
	mixins: [ PageMixin ],
	props: [ "index" ],
	components: {
		MapComponent,
		KyaneosHeader,
		ElYanportParams
	},
	computed: {
		...mapGetters([ "active_study", "editor" ]),
		text_period: function () {
			const numberOfYears = this.active_study.etudeData.scpi.yanport["page_5"]["periode_analyse"];
			return "depuis " + numberOfYears + " an" + (numberOfYears > 1 ? "s" : "");
		},
		table_offres: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [ 15, 37, 10, 16, 22 ]
				},
			};

			table.head.push(["Localisation", "Commentaires", "Surf. hab.", "Prix au m²", "Photo"]);

			for (let i = 0; i < this.active_study.etudeData.scpi.revente.offres_table_lignes; i++) {
				const loc = this.active_study.etudeData.scpi.revente.offres_table[i];

				const rows = [
					{
						parent_data: loc,
						property: "localisation",
						editable: true,
					},
					{
						parent_data: loc,
						property: "commentaire",
						editable: true,
					},
					{
						parent_data: loc,
						property: "surf_hab",
						editable: true,
						suffix: "m²"
					},
					{
						parent_data: loc,
						property: "prix_m2",
						editable: true,
						suffix: "€"
					},
					{
						parent_data: loc,
						property: "image",
						editable: true,
						type: "image",
						classes: "photo"
					},
				];

				table.body.push(rows);
			}

			return table;
		},
		table_population: function () {
			const table = { head: [], body: [], config: {
				cols_width: [ 60, 40 ]
			} };

			const loc = this.active_study.etudeData.scpi.revente.transaction_table;

			table.body = [
				[
					"Période d’observation",
					{
						parent_data: loc,
						property: "periode",
						editable: true,
						text_align: "center"
					}
				],
				[
					"Nombre de transactions",
					{
						parent_data: loc,
						property: "nombre_transactions",
						editable: true,
						text_align: "center"
					}
				],
				[
					"Prix au m² médian",
					{
						parent_data: loc,
						property: "prix_median",
						editable: true,
						suffix: "€",
						text_align: "center"
					}
				],
				[
					"Surface médiane",
					{
						parent_data: loc,
						property: "surface_mediane",
						editable: true,
						suffix: "m²",
						text_align: "center"
					}
				],
				[
					"Fourchette dominante du prix au m²",
					{
						parent_data: loc,
						property: "fourchette_dominante",
						editable: true,
						suffix: "€",
						text_align: "center"
					}
				],
			];
			
			return table;
		},
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'

.table-offres
	>>> .table .el-row__content, >>> .table .el-row__cell.photo .value
		display block

.yanport-params
	top -50px

.yanport-kpi
	p
		width : 100%
		text-align: right
</style>